import styled, { css } from "styled-components";
import { variant } from "styled-system";
import { Flex } from "../../Flex";
const prefixSuffixContainerVariants = {
    prefix: {
        borderRadius: "4px 0 0 4px",
        borderRight: "none",
    },
    suffix: {
        borderLeft: "none",
        borderRadius: "0 4px 4px 0",
    },
};
/**
 * The PrefixSuffixContainer serves as a container with specific styling for prefix and suffix elements
 */
export const PrefixSuffixContainer = styled(Flex) `
  align-items: center;

  ${({ theme: { space, borders, colors: { inputColors }, }, }) => ({
    backgroundColor: inputColors.prefixSuffixContainerBackground,
    border: borders[1],
    borderColor: inputColors.prefixSuffixContainerBorder,
    height: space[4],
    maxWidth: "min-content",
    overflow: "hidden",
    paddingLeft: space[2],
    paddingRight: space[2],
    width: "100%",
})}
  ${({ disabled, theme: { colors: { inputColors }, }, }) => disabled &&
    css `
      color: ${inputColors.prefixSuffixContainerDisabledText};
      cursor: not-allowed;
    `}

  ${variant({ variants: prefixSuffixContainerVariants })}
`;
